import React from "react";
import { useTranslation, Trans } from 'react-i18next';


export default function CulturePrinciples() {
  const { t } = useTranslation();
  const items = [
    {
      title: t('$Subheader16'),
      text: t('$OurQ1')
    },
    {
      title: t('$OurQ_Text1'),
      text: t('$OurQ2')
    },
    {
      title: t('$OurQ_Text2'),
      text: t('$OurQ3')
    },
    {
      title: t('$OurQ_Text3'),
      text: t('$OurQ4')
    },
    {
      title: t('$OurQ_Text4'),
      text: t('$OurQ5')
    },
  ];

  return (
    <section className="relative overflow-hidden bg-[#0B0D1A] text-white">
      {/* декоративные линии как на макете */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-20 top-0 h-[130%] w-px rotate-[10deg] bg-gradient-to-b from-purple-500/30 via-purple-500/10 to-transparent" />
        <div className="absolute -right-24 -top-6 h-px w-[140%] rotate-[20deg] bg-gradient-to-r from-transparent via-purple-400/20 to-transparent" />
        <div className="absolute -right-28 top-6 h-px w-[140%] rotate-[20deg] bg-gradient-to-r from-transparent via-purple-400/10 to-transparent" />
      </div>

      <div className="relative mx-auto px-[20px] sm:px-[100px] lg:px-[200px] py-16 lg:py-24">
        {/* Заголовок */}
        <h1 className="text-center text-3xl sm:text-4xl font-bold tracking-tight">
          <Trans
            i18nKey="$Header11"
            components={{ span: <span className="bg-gradient-to-r from-purple-400 to-purple-300 bg-clip-text text-transparent"></span> }}
          />
        </h1>
        <p className="mt-2 text-center text-sm text-gray-400">
          {t('$Subheader151')}
        </p>

        {/* Подзаголовок */}
        <p className="mt-6 max-w-3xl mx-auto text-center text-gray-400">
          {t('$Subheader15')}
        </p>

        {/* Карточки принципов */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-12">
          {items.map(({ title, text }, idx) => (
            <div key={idx} className="max-w-[28rem]">
              <div className="text-sm font-semibold">
                <span className="bg-gradient-to-r from-purple-400 to-purple-300 bg-clip-text text-transparent">
                  {String(idx + 1).padStart(2, "0")}.
                </span>{" "}
                <span className="text-white/90">{title}</span>
              </div>
              <p className="mt-3 text-sm leading-6 text-gray-400">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
